Vue.component('domains', {
    props: ['client-id'],

    data() {
        return {
            loading: false,

            verifying: false,

            deleting: false,

            domains: [],

            activeDomain: null,

            deleteId: 0,

            verifiedStatus: {},

            createDomainForm: $.extend(true, new Form({
                data: {
                    domain: ''
                }
            }), {})
        };
    },

    mounted() {
        this.getDomains();
    },

    methods: {
        getDomains () {
            this.loading = true;

            axios.get('/api/domains', {
                params: {
                    client_id: this.clientId
                }
            }).then((response) => {
                this.domains = response.data;

                this.loading = false;
            });
        },

        create () {
            Http.post('/api/domains/create', this.createDomainForm, {
                params: {
                    client_id: this.clientId
                }
            }).then((response) => {
                // Reset, no need to display
                this.createDomainForm.resetForm();
                this.createDomainForm.resetAlert();

                // Reload the main list
                this.getDomains();

                // Open the DNS information
                $('#domain-create').modal('hide');

                if (response.status === 'pending') {
                    this.viewDnsRecords(response.domain_id);
                }
            });
        },

        remove (id) {
            $('#domain-delete').modal('show');

            this.deleteId = id;
        },

        doRemove () {
            this.deleting = true;

            axios.post('/api/domains/delete', {}, {
                params: {
                    id: this.deleteId
                }
            }).then( (response) => {
                if (response.status === 200) {
                    $('#domain-delete').modal('hide');

                    this.deleting = false;

                    this.getDomains();
                }
            });
        },

        viewDnsRecords (id) {
            $('#domain-dns').modal('show');

            this.modalLoading = true;

            axios.get('/api/domains/dns', {
                params: {
                    id
                }
            }).then((response) => {
                this.activeDomain = response.data;

                this.modalLoading = false;
            });
        },

        verify (id, modal) {
            this.verifying = true;

            axios.post('/api/domains/verify', {}, {
                params: {
                    id
                }
            }).then((response) => {
                this.verifying = false;

                this.verifiedStatus = response.data;

                if (response.data.status === true) {
                    this.getDomains();
                }

                $('#domain-verified').modal('show');
            });
        }
    }
});
